webpackJsonp([11],{

/***/ 527:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f582a1a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(877);
function injectStyle (ssrContext) {
  __webpack_require__(874)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f582a1a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 530:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);

var defaultMapFunction = function defaultMapFunction(data) {
  return { value: data, label: data };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  make: function make(dataArray, mapFunction) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()(dataArray.map(
    // Use the default map function if no mapFunction is provided
    typeof mapFunction === 'function' ? mapFunction : defaultMapFunction));
  }
});

/***/ }),

/***/ 531:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()(['Singapore', 'Malaysia', 'Taiwan', 'South Korea', 'Hong Kong', 'Philippines', 'Thailand', 'Vietnam', 'Indonesia', 'Japan', 'Afghanistan', 'Albania', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla', 'Antarctica', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Bouvet Island', 'Brazil', 'British Indian Ocean Territory', 'Brunei Darussalam', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Cayman Islands', 'Central African Republic', 'Chad', 'Chile', 'China', 'Christmas Island', 'Cocos Islands', 'Colombia', 'Comoros', 'Congo', 'Congo, Democratic Republic of the', 'Cook Islands', 'Costa Rica', 'Cote d\'Ivoire', 'Croatia', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Falkland Islands', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'French Guiana', 'French Polynesia', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guadeloupe', 'Guam', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Heard Island and McDonald Islands', 'Honduras', 'Hungary', 'Iceland', 'India', 'Iran', 'Iraq', 'Ireland', 'Israel', 'Italy', 'Jamaica', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macao', 'Madagascar', 'Malawi', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Martinique', 'Mauritania', 'Mauritius', 'Mayotte', 'Mexico', 'Micronesia', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'Netherlands Antilles', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Norfolk Island', 'North Korea', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Palestinian Territory', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Pitcairn', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Romania', 'Russian Federation', 'Rwanda', 'Saint Helena', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Pierre and Miquelon', 'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Georgia', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Svalbard and Jan Mayen', 'Swaziland', 'Sweden', 'Switzerland', 'Syrian Arab Republic', 'Tajikistan', 'Tanzania', 'The Former Yugoslav Republic of Macedonia', 'Timor-Leste', 'Togo', 'Tokelau', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'United States Minor Outlying Islands', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican City', 'Venezuela', 'Virgin Islands, British', 'Virgin Islands, U.S', 'Wallis and Futuna', 'Western Sahara', 'Yemen', 'Zambia', 'Zimbabwe']));

/***/ }),

/***/ 532:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

var formValidationMixin = {
  methods: {
    validate: function validate(prop) {
      var forms = [];
      if (Array.isArray(this.$refs.form)) {
        forms = this.$refs.form;
      } else {
        forms.push(this.$refs.form);
      }

      var promises = forms.map(function (formC) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          if (prop) {
            formC.validateField(prop, function (errorMessage) {
              if (!errorMessage) resolve();else reject(new Error(errorMessage));
            });
          } else {
            formC.validate(function (valid) {
              if (valid) resolve();else reject(formC);
            });
          }
        });
      });
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises);
    }
  },
  mounted: function mounted() {
    // Require updateForm to exist
    if (!this.$refs.form) throw new Error('formValidationMixin require a reference to `form`.');
  }
};

/* harmony default export */ __webpack_exports__["a"] = (formValidationMixin);

/***/ }),

/***/ 539:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilmmakerDetailsForm_vue__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f2c72ce_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilmmakerDetailsForm_vue__ = __webpack_require__(543);
function injectStyle (ssrContext) {
  __webpack_require__(540)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f2c72ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilmmakerDetailsForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f2c72ce_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilmmakerDetailsForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 540:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(541);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(512)("56e2b31f", content, true);

/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(511)(true);
// imports


// module
exports.push([module.i, ".el-select[data-v-5f2c72ce]{display:block}", "", {"version":3,"sources":["/app/src/components/Profile/FilmmakerDetailsForm.vue"],"names":[],"mappings":"AAoHA,4BACE,aAAe,CAChB","file":"FilmmakerDetailsForm.vue","sourcesContent":["/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* Font\n-------------------------- */\n/* Element Chalk Variables */\n/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* 53a8ff */\n/* 66b1ff */\n/* 79bbff */\n/* 8cc5ff */\n/* a0cfff */\n/* b3d8ff */\n/* c6e2ff */\n/* d9ecff */\n/* ecf5ff */\n/* Link\n-------------------------- */\n/* Background\n-------------------------- */\n/* Border\n-------------------------- */\n/* Box-shadow\n-------------------------- */\n/* Fill\n-------------------------- */\n/* Font\n-------------------------- */\n/* Size\n-------------------------- */\n/* z-index\n-------------------------- */\n/* Disable base\n-------------------------- */\n/* Icon\n-------------------------- */\n/* Checkbox\n-------------------------- */\n/* Radio\n-------------------------- */\n/* Select\n-------------------------- */\n/* Alert\n-------------------------- */\n/* Message Box\n-------------------------- */\n/* Message\n-------------------------- */\n/* Notification\n-------------------------- */\n/* Input\n-------------------------- */\n/* Cascader\n-------------------------- */\n/* Group\n-------------------------- */\n/* Tab\n-------------------------- */\n/* Button\n-------------------------- */\n/* cascader\n-------------------------- */\n/* Switch\n-------------------------- */\n/* Dialog\n-------------------------- */\n/* Table\n-------------------------- */\n/* Pagination\n-------------------------- */\n/* Popover\n-------------------------- */\n/* Tooltip\n-------------------------- */\n/* Tag\n-------------------------- */\n/* Tree\n-------------------------- */\n/* Dropdown\n-------------------------- */\n/* Badge\n-------------------------- */\n/* Card\n--------------------------*/\n/* Slider\n--------------------------*/\n/* Steps\n--------------------------*/\n/* Menu\n--------------------------*/\n/* Rate\n--------------------------*/\n/* DatePicker\n--------------------------*/\n/* Loading\n--------------------------*/\n/* Scrollbar\n--------------------------*/\n/* Carousel\n--------------------------*/\n/* Collapse\n--------------------------*/\n/* Transfer\n--------------------------*/\n/* Header\n  --------------------------*/\n/* Footer\n--------------------------*/\n/* Main\n--------------------------*/\n/* Break-point\n--------------------------*/\n.el-select[data-v-5f2c72ce] {\n  display: block;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 542:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_formValidationMixin__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_selectorDataMaker__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_data_countries__ = __webpack_require__(531);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// Data


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_formValidationMixin__["a" /* default */]],
  props: {
    value: {},
    editable: {
      type: Boolean,
      default: true
    },
    showReferral: {
      type: Boolean,
      default: true
    },
    showEmail: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      form: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.value),
      rules: {
        name: [{ required: true, trigger: 'change' }],
        email: [{ type: 'email', trigger: 'blur' }, { required: true, trigger: 'change' }],
        contact_number: [{ required: true, trigger: 'change', message: 'contact number is required' }, { min: 6, trigger: 'blur', message: 'contact number is required' }],
        address: [{ required: true, trigger: 'change' }],
        city: [{ required: true, trigger: 'change' }],
        postal_code: [{ required: true, trigger: 'change' }],
        country: [{ required: true, trigger: 'change' }],
        company_name: []
      },
      countries: __WEBPACK_IMPORTED_MODULE_2__utils_selectorDataMaker__["a" /* default */].make(__WEBPACK_IMPORTED_MODULE_3__assets_data_countries__["a" /* default */])
    };
  },

  methods: {
    input: function input() {
      this.$emit('input', this.form);
    }
  }
});

/***/ }),

/***/ 543:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form',{ref:"form",attrs:{"label-position":"top","model":_vm.form,"rules":_vm.rules}},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"xs":24,"sm":_vm.showEmail ? 24 : 12}},[_c('el-form-item',{attrs:{"label":"Full name of rights holder","prop":"name"}},[_c('el-input',{attrs:{"auto-complete":"name","disabled":!_vm.editable},on:{"input":_vm.input},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1)],1),_vm._v(" "),(_vm.showEmail)?_c('el-col',{attrs:{"xs":24,"sm":12}},[_c('el-form-item',{attrs:{"label":"Email","prop":"email"}},[_c('el-input',{attrs:{"auto-complete":"email","disabled":!_vm.editable},on:{"input":_vm.input},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}})],1)],1):_vm._e(),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12}},[_c('el-form-item',{attrs:{"label":"Contact number","prop":"contact_number"}},[_c('sh-el-tel-input',{attrs:{"disabled":!_vm.editable},model:{value:(_vm.form.contact_number),callback:function ($$v) {_vm.$set(_vm.form, "contact_number", $$v)},expression:"form.contact_number"}}),_vm._v(" "),_c('el-input',{staticStyle:{"display":"none"},attrs:{"value":_vm.form.contact_number}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12}},[_c('el-form-item',{attrs:{"label":"Address","prop":"address"}},[_c('el-input',{attrs:{"auto-complete":"address-line1","disabled":!_vm.editable},on:{"input":_vm.input},model:{value:(_vm.form.address),callback:function ($$v) {_vm.$set(_vm.form, "address", $$v)},expression:"form.address"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":6}},[_c('el-form-item',{attrs:{"label":"City","prop":"city"}},[_c('el-input',{attrs:{"auto-complete":"address-level2","disabled":!_vm.editable},on:{"input":_vm.input},model:{value:(_vm.form.city),callback:function ($$v) {_vm.$set(_vm.form, "city", $$v)},expression:"form.city"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":6}},[_c('el-form-item',{attrs:{"label":"Postal Code","prop":"postal_code"}},[_c('el-input',{attrs:{"auto-complete":"postal-code","disabled":!_vm.editable},on:{"input":_vm.input},model:{value:(_vm.form.postal_code),callback:function ($$v) {_vm.$set(_vm.form, "postal_code", $$v)},expression:"form.postal_code"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12}},[_c('el-form-item',{attrs:{"label":"Country","prop":"country"}},[_c('el-select',{attrs:{"disabled":!_vm.editable,"filterable":""},on:{"input":_vm.input},model:{value:(_vm.form.country),callback:function ($$v) {_vm.$set(_vm.form, "country", $$v)},expression:"form.country"}},_vm._l((_vm.countries),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}))],1)],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12}},[_c('el-form-item',{attrs:{"label":"Company name","prop":"company_name"}},[_c('el-input',{attrs:{"auto-complete":"off","disabled":!_vm.editable},on:{"input":_vm.input},model:{value:(_vm.form.company_name),callback:function ($$v) {_vm.$set(_vm.form, "company_name", $$v)},expression:"form.company_name"}})],1)],1),_vm._v(" "),(_vm.showReferral)?_c('el-col',{attrs:{"xs":24,"sm":12}},[_c('el-form-item',{attrs:{"label":"Referral","prop":"referral"}},[_c('p',{staticClass:"instruction"},[_vm._v("\n          Film festival or curator who recommended you to Viddsee\n        ")]),_vm._v(" "),_c('el-input',{attrs:{"auto-complete":"off"},on:{"input":_vm.input},model:{value:(_vm.form.referral),callback:function ($$v) {_vm.$set(_vm.form, "referral", $$v)},expression:"form.referral"}})],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 874:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(875);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(512)("7cc32a74", content, true);

/***/ }),

/***/ 875:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(511)(true);
// imports


// module
exports.push([module.i, ".profile .el-input.is-disabled input{background-color:#fff;color:#000;cursor:default}.profile .el-form-item__label:before{visibility:hidden}.link{text-decoration:underline;cursor:pointer}", "", {"version":3,"sources":["/app/src/components/Profile/index.vue"],"names":[],"mappings":"AAoHA,qCACE,sBAAwB,AACxB,WAAa,AACb,cAAgB,CACjB,AACD,qCACE,iBAAmB,CACpB,AACD,MACE,0BAA2B,AAC3B,cAAgB,CACjB","file":"index.vue","sourcesContent":["/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* Font\n-------------------------- */\n/* Element Chalk Variables */\n/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* 53a8ff */\n/* 66b1ff */\n/* 79bbff */\n/* 8cc5ff */\n/* a0cfff */\n/* b3d8ff */\n/* c6e2ff */\n/* d9ecff */\n/* ecf5ff */\n/* Link\n-------------------------- */\n/* Background\n-------------------------- */\n/* Border\n-------------------------- */\n/* Box-shadow\n-------------------------- */\n/* Fill\n-------------------------- */\n/* Font\n-------------------------- */\n/* Size\n-------------------------- */\n/* z-index\n-------------------------- */\n/* Disable base\n-------------------------- */\n/* Icon\n-------------------------- */\n/* Checkbox\n-------------------------- */\n/* Radio\n-------------------------- */\n/* Select\n-------------------------- */\n/* Alert\n-------------------------- */\n/* Message Box\n-------------------------- */\n/* Message\n-------------------------- */\n/* Notification\n-------------------------- */\n/* Input\n-------------------------- */\n/* Cascader\n-------------------------- */\n/* Group\n-------------------------- */\n/* Tab\n-------------------------- */\n/* Button\n-------------------------- */\n/* cascader\n-------------------------- */\n/* Switch\n-------------------------- */\n/* Dialog\n-------------------------- */\n/* Table\n-------------------------- */\n/* Pagination\n-------------------------- */\n/* Popover\n-------------------------- */\n/* Tooltip\n-------------------------- */\n/* Tag\n-------------------------- */\n/* Tree\n-------------------------- */\n/* Dropdown\n-------------------------- */\n/* Badge\n-------------------------- */\n/* Card\n--------------------------*/\n/* Slider\n--------------------------*/\n/* Steps\n--------------------------*/\n/* Menu\n--------------------------*/\n/* Rate\n--------------------------*/\n/* DatePicker\n--------------------------*/\n/* Loading\n--------------------------*/\n/* Scrollbar\n--------------------------*/\n/* Carousel\n--------------------------*/\n/* Collapse\n--------------------------*/\n/* Transfer\n--------------------------*/\n/* Header\n  --------------------------*/\n/* Footer\n--------------------------*/\n/* Main\n--------------------------*/\n/* Break-point\n--------------------------*/\n.profile .el-input.is-disabled input {\n  background-color: white;\n  color: black;\n  cursor: default;\n}\n.profile .el-form-item__label::before {\n  visibility: hidden;\n}\n.link {\n  text-decoration: underline;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 876:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Utilities_SupportButton__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FilmmakerDetailsForm__ = __webpack_require__(539);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FilmmakerDetailsForm: __WEBPACK_IMPORTED_MODULE_1__FilmmakerDetailsForm__["a" /* default */],
    SupportButton: __WEBPACK_IMPORTED_MODULE_0__components_Utilities_SupportButton__["a" /* default */]
  },
  computed: {
    account: function account() {
      return this.$store.state.account.blob.film_maker_details;
    }
  },
  data: function data() {
    return {
      editable: false
    };
  }
});

/***/ }),

/***/ 877:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile content-width"},[_c('el-alert',{staticStyle:{"margin-bottom":"1.5em"},attrs:{"title":"This section shows your account information.","type":"info","show-icon":""}},[_c('div',[_c('small',[_vm._v("Please "),_c('SupportButton',{staticClass:"link"},[_vm._v("contact us")]),_vm._v(" if you spot any error.")],1)])]),_vm._v(" "),_c('FilmmakerDetailsForm',{attrs:{"editable":false,"showReferral":false},model:{value:(_vm.account),callback:function ($$v) {_vm.account=$$v},expression:"account"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// js/11.3a40591d65db5ef31731.js